import { verifyUserLoginStatus } from 'apps/user/helpers';
import { arrayContainsArray } from 'utils/array';
import { setNoRouteAccess } from 'apps/user/actions/user';

export default function getOnEnterHandler(
  loginStatusRequirement,
  requiredBetaFeatures,
  onRequirementsNotFulfilledParams
) {
  return function onEnterHandler(nextState, replace, path, extras) {
    const { store: { dispatch }, store } = extras;
    const { user } = store.getState();

    const loginStatusRequirementPass = verifyUserLoginStatus(user, loginStatusRequirement);
    const betaFeatureRequirementsPass = arrayContainsArray(user.betaFeatures, requiredBetaFeatures);

    if (!loginStatusRequirementPass || !betaFeatureRequirementsPass) {
      onRequirementsNotFulfilled(dispatch, replace, onRequirementsNotFulfilledParams);

      return false;
    }

    return true;
  };
}

function onRequirementsNotFulfilled(dispatch, replace, onRequirementsNotFulfilledParams) {
  const { redirectToPath, shouldSetNoRouteAccess } = onRequirementsNotFulfilledParams;
  replace(redirectToPath);

  if (shouldSetNoRouteAccess) {
    dispatch(setNoRouteAccess());
  }
}
